import { message } from 'antd';
import i18n from '../i18n';
import { instance } from './axios.instance';

// Styles de screenshot planning gérés dans l'admin. L'éditeur ne stocke pas
// l'id seul : il fige une copie des couleurs sur la box (cf. tableConfig.theme),
// pour qu'une modification du style en admin ne change jamais un document déjà
// composé. `theme_digest` sert uniquement à détecter qu'un style a évolué depuis
// le choix, et à proposer la mise à jour.
export const getPlanningScreenshotStyles = async (work = null) => {
  const query = work ? `?work=${encodeURIComponent(work)}` : '';
  try {
    const { data } = await instance.get(`/planning_screenshot_styles${query}`);
    return data;
  } catch (error) {
    // Sans ce message, un échec se traduit par un sélecteur vide et rien
    // d'autre : l'intercepteur axios ne signale que les 401 et 404.
    console.error(error);
    message.error({
      content: i18n.t('planning-style-load-error'),
      key: 'planning-style-load-error',
    });
    return { styles: [], default_theme: null };
  }
};
